var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscussions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 536.298,
    height: 369.323,
    viewBox: "0 0 536.298 369.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb3780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b7ce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_75",
    x: 139.106,
    y: 222.323,
    width: 182,
    height: 147,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.367,
    y1: 0.284,
    x2: 1.173,
    y2: 1.089,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00baef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#00baef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.109,
    y1: 0.076,
    x2: 0.774,
    y2: 0.62,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b7ce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00baef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "messaging",
    transform: "translate(-0.588 538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M107.429-470H489.867a13.584,13.584,0,0,1,13.584,13.584v255.477H93.844V-456.416A13.584,13.584,0,0,1,107.429-470Z",
    transform: "translate(-29.915 -21.813)",
    fill: "#313e48",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M112.825-445.69H497.252v235.435H112.825Z",
    transform: "translate(-36.003 -29.611)",
    fill: "#f1f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M117.168-210.444H223.183V-439.925H117.168Z",
    transform: "translate(-37.397 -32.819)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M117.825-212.047H495.46V-440.69H117.825Z",
    transform: "translate(-37.607 -31.215)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M545.471-440.9v228.377H275.383Z",
    transform: "translate(-88.149 -31.147)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M.588-58.784h536.29V-73.865H.588Z",
    transform: "translate(0 -148.886)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M.588-51.661H536.882q.173,6.636-7.676,6.636H11.436Q.588-45.025.588-51.661Z",
    transform: "translate(0 -156.009)",
    fill: "#9a9b9a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M542.149-373.717h44.882v71.023H542.149a17.644,17.644,0,0,1-17.54-17.744v-35.523A17.643,17.643,0,0,1,542.149-373.717Z",
    transform: "translate(-168.096 -52.699)",
    fill: "#88472b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M598.939-364.839a8.917,8.917,0,0,0,8.952,8.878h8.952a8.917,8.917,0,0,0,8.952-8.878h0a8.917,8.917,0,0,0-8.952-8.878h-8.952a8.917,8.917,0,0,0-8.952,8.878Z",
    transform: "translate(-191.94 -52.699)",
    fill: "#88472b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M585.759-338.7a8.917,8.917,0,0,0,8.952,8.878h17.9a8.917,8.917,0,0,0,8.952-8.878h0a8.917,8.917,0,0,0-8.952-8.878h-17.9a8.917,8.917,0,0,0-8.952,8.878Z",
    transform: "translate(-187.712 -61.085)",
    fill: "#88472b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M581.366-312.556a8.917,8.917,0,0,0,8.952,8.878h17.9a8.916,8.916,0,0,0,8.952-8.878h0a8.917,8.917,0,0,0-8.952-8.878h-17.9a8.917,8.917,0,0,0-8.952,8.878Z",
    transform: "translate(-186.303 -69.47)",
    fill: "#88472b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M576.973-286.415a8.916,8.916,0,0,0,8.952,8.878h17.9a8.916,8.916,0,0,0,8.952-8.878h0a8.916,8.916,0,0,0-8.952-8.878h-17.9a8.916,8.916,0,0,0-8.952,8.878Z",
    transform: "translate(-184.893 -77.856)",
    fill: "#88472b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M550.1-403.61a24.965,24.965,0,0,0,5.717-10.745l2.16-8.745a3.786,3.786,0,0,1,3.673-2.9h2.014c5.314,0,8.856,5.919,8.856,9.745v4.122c0,8.369-1.352,16.6-5.41,23.888l-7.836,14.092-24.448-12.624Z",
    transform: "translate(-171.376 -35.928)",
    fill: "#88472b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M624.062-347.576H611.022a3.076,3.076,0,0,0-3.26,2.854,3.076,3.076,0,0,0,3.26,2.854Z",
    transform: "translate(-194.77 -61.085)",
    fill: "#331d13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M619.262-322.368H606.223a3.076,3.076,0,0,0-3.26,2.854,3.076,3.076,0,0,0,3.26,2.854Z",
    transform: "translate(-193.231 -69.171)",
    fill: "#331d13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M614.463-297.16H601.423a3.076,3.076,0,0,0-3.26,2.854,3.076,3.076,0,0,0,3.26,2.854Z",
    transform: "translate(-191.691 -77.257)",
    fill: "#331d13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M504.855-367.182V-300.6h-31.6l-9.478-66.584Zm-15.973,44.39a6.754,6.754,0,0,0-6.846,6.658,6.754,6.754,0,0,0,6.846,6.658,6.754,6.754,0,0,0,6.846-6.658A6.754,6.754,0,0,0,488.882-322.792Z",
    transform: "translate(-148.584 -54.795)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.59, -538)",
    filter: "url(#Rectangle_75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75-2",
    "data-name": "Rectangle 75",
    width: 164,
    height: 129,
    rx: 3,
    transform: "translate(148.11 228.32)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M240.641-130.513H377.034v-27.453H240.641Z",
    transform: "translate(-77.004 -121.908)",
    fill: "#ededee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M263.313-93.632H384.306v-10.981H263.313Z",
    transform: "translate(-84.277 -139.022)",
    fill: "#ededee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M242.417-104.613h4.207a3.4,3.4,0,0,1,3.4,3.4v4.189a3.4,3.4,0,0,1-3.4,3.4h-4.207a3.4,3.4,0,0,1-3.4-3.4v-4.189A3.4,3.4,0,0,1,242.417-104.613Z",
    transform: "translate(-76.485 -139.022)",
    fill: "#ededee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M263.313-64.531H384.306V-75.512H263.313Z",
    transform: "translate(-84.277 -148.357)",
    fill: "#ededee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M242.417-75.512h4.207a3.4,3.4,0,0,1,3.4,3.4v4.189a3.4,3.4,0,0,1-3.4,3.4h-4.207a3.4,3.4,0,0,1-3.4-3.4v-4.189A3.4,3.4,0,0,1,242.417-75.512Z",
    transform: "translate(-76.485 -148.357)",
    fill: "#ededee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M382.889-46.411H420.87a1.358,1.358,0,0,1,1.358,1.358v10.46a1.358,1.358,0,0,1-1.358,1.358H382.889a1.358,1.358,0,0,1-1.358-1.358v-10.46A1.358,1.358,0,0,1,382.889-46.411Z",
    transform: "translate(-122.199 -157.693)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M222.305-200H380.763a2.717,2.717,0,0,1,2.717,2.717v12.657H219.588v-12.657A2.717,2.717,0,0,1,222.305-200Z",
    transform: "translate(-70.251 -108.424)",
    fill: "#d1d1d1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M536.331-162.361a2.5,2.5,0,0,1-1.763-.688,1.936,1.936,0,0,1-.626-1.72l1.934-12.385h-9.671a2.533,2.533,0,0,1-1.877-.745,2.575,2.575,0,0,1-.739-1.892v-6.651a2.575,2.575,0,0,1,.739-1.892,2.533,2.533,0,0,1,1.877-.745h11.377l2.5-17.2H529.163a2.533,2.533,0,0,1-1.877-.745,2.574,2.574,0,0,1-.74-1.892v-6.651a2.574,2.574,0,0,1,.74-1.892,2.533,2.533,0,0,1,1.877-.745h12.742l1.82-12.385a3.43,3.43,0,0,1,.91-1.72,2.306,2.306,0,0,1,1.707-.688h6.712a2.306,2.306,0,0,1,1.707.688,2.343,2.343,0,0,1,.683,1.72l-1.82,12.385h14.108l1.82-12.385a3.431,3.431,0,0,1,.91-1.72,2.306,2.306,0,0,1,1.706-.688h6.713a2.306,2.306,0,0,1,1.707.688,2.344,2.344,0,0,1,.683,1.72l-1.82,12.385h9.443a2.533,2.533,0,0,1,1.877.745,2.574,2.574,0,0,1,.739,1.892v6.651a2.574,2.574,0,0,1-.739,1.892,2.533,2.533,0,0,1-1.877.745h-11.15l-2.617,17.2h10.808a2.533,2.533,0,0,1,1.877.745,2.574,2.574,0,0,1,.74,1.892v6.651a2.574,2.574,0,0,1-.74,1.892,2.533,2.533,0,0,1-1.877.745H573.42l-1.82,12.385a3.43,3.43,0,0,1-.91,1.72,2.45,2.45,0,0,1-1.82.688h-6.713a2.5,2.5,0,0,1-1.764-.688,1.937,1.937,0,0,1-.626-1.72l1.934-12.385H547.594l-1.82,12.385a3.431,3.431,0,0,1-.91,1.72,2.449,2.449,0,0,1-1.82.688Zm13.55-27.593h13.957l2.476-17.66H552.469Z",
    transform: "translate(-167.769 -97.838)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M170.6-326.755a7.288,7.288,0,0,0,3.889,6.407l-4,12.475c-.2-.011-.412-.045-.618-.045a10.238,10.238,0,0,0-7.709,3.532l-9.356-8.128a6.426,6.426,0,0,0,.961-3.373,6.578,6.578,0,0,0-6.588-6.52,6.578,6.578,0,0,0-6.588,6.52,6.578,6.578,0,0,0,6.588,6.52,6.607,6.607,0,0,0,3.569-1.041l9.791,8.468a9.925,9.925,0,0,0-.915,4.166,10.028,10.028,0,0,0,2.059,6.045l-8.51,8.422a8.016,8.016,0,0,0-4.53-1.426,8.034,8.034,0,0,0-8.052,7.969,8.034,8.034,0,0,0,8.052,7.969,8.034,8.034,0,0,0,8.052-7.969,7.8,7.8,0,0,0-1.441-4.505l8.487-8.4a10.225,10.225,0,0,0,6.131,2.038,10.235,10.235,0,0,0,5.65-1.675l3.98,4.438a7.127,7.127,0,0,0-1.578,4.483,7.3,7.3,0,0,0,7.32,7.245,7.3,7.3,0,0,0,7.32-7.245,7.3,7.3,0,0,0-7.32-7.245,7.293,7.293,0,0,0-3.477.883l-4.072-4.505a10.057,10.057,0,0,0,2.425-6.52,9.934,9.934,0,0,0-.366-2.672l16.059-4.89a5.873,5.873,0,0,0,4.8,2.49,5.849,5.849,0,0,0,5.856-5.8,5.849,5.849,0,0,0-5.856-5.8,5.849,5.849,0,0,0-5.856,5.8,5.042,5.042,0,0,0,.023.589l-16.219,4.936a10.275,10.275,0,0,0-5.193-4.166l3.935-12.248c.2.017.412.023.618.023a7.3,7.3,0,0,0,7.32-7.245,7.3,7.3,0,0,0-7.32-7.245A7.3,7.3,0,0,0,170.6-326.755Z",
    transform: "translate(-44.909 -65.439)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M249.5-404.635h61.454L334-381.59v-84.5a15.364,15.364,0,0,0-15.363-15.363H249.5a15.364,15.364,0,0,0-15.363,15.363V-420A15.364,15.364,0,0,0,249.5-404.635",
    transform: "translate(-74.918 -18.14)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M267.33-461.183H201l-23.411,23.045v-84.5A15.487,15.487,0,0,1,193.2-538H267.33a15.487,15.487,0,0,1,15.607,15.363v46.09a15.487,15.487,0,0,1-15.607,15.363",
    transform: "translate(-56.778)",
    fill: "url(#linear-gradient-6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussions);
export default __webpack_public_path__ + "static/media/discussions.0bb74f200877142b87cc95c46f0c5368.svg";
export { ForwardRef as ReactComponent };